import React, { useState } from "react";
import { connect } from "react-redux";
import VisibilitySensor from "react-visibility-sensor/visibility-sensor";
import { actions, readingActions, signinActions } from "../../../actions";
import * as socialControlsActions from "../../../actions/socialControlsActions";
import { Episode as EpisodeView } from "../../design/Episode";
import EpisodeLastPage from "../Episode/LastPage";
import { withPaidCheck } from "../paidContentCheck";
import EpisodeDisabled from "../Episode/EpisodeDisabled";
import NovelReadingControls from "./NovelReadingControls";
import { setupNovelSettingsHandlers, postAllToIframe } from "./settingsHandling";

// const contentServer =
// process.env.NODE_ENV === "production" ? routes().get_episode_epub : "/test-content/";

const contentServer = routes().get_episode_epub;

export const EpisodeNovel = ({ closeAllLists, lastPageSetVisible, episode }) => {
  const iframeRef = React.useRef();
  const [loaded, setLoaded] = React.useState(false);
  const [showLastPage, setShowLastPage] = useState(false);
  const settingsUpdaters = React.useMemo(
    () => iframeRef.current && setupNovelSettingsHandlers(iframeRef.current),
    [loaded]
  );
  const [contentHeight, setContentHeight] = React.useState(0);

  React.useLayoutEffect(() => {
    window.addEventListener("message", handleIframeMessage, false);
  }, []);

  const chapterUrl = `${contentServer}${episode.chapter_path}`;

  function onChapterLoad(_) {
    postAllToIframe(iframeRef.current);
    setLoaded(true);
    setTimeout(lastPageSetVisible, 500);
  }

  function handleIframeMessage({ data }) {
    const { type, payload } = data || {};
    type === "height" && setContentHeight(payload);
  }

  return (
    <EpisodeView onClick={closeAllLists}>
      <div
        id="chapter-content"
        className="mb4 overflow-hidden"
        style={{
          visibility: loaded ? "visible" : "hidden",
          height: `${contentHeight}px`
        }}
      >
        <iframe
          ref={iframeRef}
          className="db mx-auto w-100 w-80-ns w-75-m"
          height="100%"
          scrolling="no"
          frameBorder="no"
          src={chapterUrl}
          onLoad={onChapterLoad}
        />
      </div>
      <VisibilitySensor
        onChange={isVisible => {
          loaded && isVisible && setShowLastPage(true);
        }}
      >
        <div style={{ height: "5px" }} />
      </VisibilitySensor>
      <div className="mb3">
        {loaded && showLastPage ? <EpisodeLastPage /> : <div style={{ height: "500px" }} />}
      </div>

      {loaded && <NovelReadingControls settingsUpdaters={settingsUpdaters} />}
    </EpisodeView>
  );
};

const mapState = (state, ownProps) => ({
  story: state.story,
  episode: state.currentEpisode,
  ...state.reading
});

const mapDispatch = (dispatch, ownProps) => ({
  closeAllLists: () => {
    dispatch(actions.episodesControlsSetClosed());
    dispatch(socialControlsActions.closeDrawer());
    dispatch(socialControlsActions.closeSocialDropdown());
    dispatch(signinActions.closeLanguageMenu());
    dispatch(signinActions.closeUserMenu());
  },
  lastPageSetVisible: () => {
    dispatch(readingActions.lastPageSetVisible());
  },
  openSigninModalWithCallback: (callback, callbackType, callbackArgs) => {
    dispatch(signinActions.openModalWithCallback(callback, callbackType, callbackArgs));
  }
});

const EpisodeEnabled = connect(mapState, mapDispatch)(EpisodeNovel);
const AuthorizedEpisodeNovel = withPaidCheck(EpisodeEnabled, EpisodeDisabled);

export default AuthorizedEpisodeNovel;
